import { queryFetcher } from "@utilities/helpers/queryFetcher";
import { QueryOptions } from "@utilities/helpers/queryParser.types";
import React from "react";
import useSWR from "swr";

export function useListVideo<T>(defaultOptions?: QueryOptions) {
  const endpoint = "/api/v1/videos";

  const [options, setOptions] = React.useState<QueryOptions>({
    size: 10,
    populated: true,
    ...defaultOptions,
  });

  const { data, isValidating, revalidate } = useSWR(
    [endpoint, options],
    queryFetcher,
  );

  const result = data?.data as T[];

  return {
    data: result || [],
    count: data?.count || 0,
    error: data?.error || null,
    isLoading: isValidating,
    reload: revalidate,
    options,
    setOptions,
  };
}
